import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const PluginRemoveIcon = (props) => {
    const { plugin, onClickBehavior } = props;

    if (plugin.isInherited) {
        return (
            <FontAwesomeIcon
                icon={faTrash}
                title="Unable to remove Inherited plugin"
                className="options-icon invalid-icon"
            />
        );
    }

    return (
        <FontAwesomeIcon
            icon={faTrash}
            className="options-icon removable-icon"
            title="Remove"
            onClick={() => onClickBehavior(plugin)}
        />
    );
};

export default PluginRemoveIcon;
